export default __webpack_public_path__ + "static/media/grocery-primary.2a97ca52.svg";